/**
 * Utilitaire pour générer des URLs dynamiques selon l'environnement
 */

/**
 * Génère l'URL de base de l'application
 * @returns {string} URL de base
 */
export const getBaseUrl = () => {
  // Si on est en développement, utiliser localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000';
  }
  
  // Si on a une URL custom définie (pour le domaine personnalisé)
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL;
  }
  
  // En production, détecter automatiquement l'URL
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}`;
  }
  
  // Fallback pour le rendu côté serveur (utilise variable d'environnement si disponible)
  return process.env.REACT_APP_SITE_URL || `${window?.location?.protocol}//${window?.location?.host}` || 'http://localhost:3000';
};

/**
 * Génère une URL complète pour une route donnée
 * @param {string} path - Le chemin de la route (ex: '/services', '/contact')
 * @returns {string} URL complète
 */
export const getFullUrl = (path = '') => {
  const baseUrl = getBaseUrl();
  // S'assurer que le path commence par un slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Génère une URL d'image complète
 * @param {string} imagePath - Le chemin de l'image (ex: '/mmd-logo.png')
 * @returns {string} URL complète de l'image
 */
export const getImageUrl = (imagePath) => {
  const baseUrl = getBaseUrl();
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${baseUrl}${cleanPath}`;
};